<!--
	@name common-structure-directory
	@description Video Player
	@date 2020/04/11
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name">
		<template #body>
			<div v-if="obj.source" class="video-container" style="padding:56.25% 0 0 0;position:relative; overflow: hidden;">
				<iframe :src="`https://player.vimeo.com/video/${obj.source}?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479${obj.h ? `&amp;h=${obj.h}` : ''}`" frameborder="0" allow="autoplay;fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;" />
			</div>
		</template>
	</common-dialog>
</template>

<script>
	import { EventBus } from '@/utils';
	import CommonDialog from '@/component/common/dialog';

	export default {
		name: 'app-dialog-vimeo-player',

		components: { CommonDialog },

		data() {
			return {
				obj: { source:null, h:null}
			};
		},

		created() {
			EventBus.$on('common-dialog-closed', this.close);
		},

		destroyed() {
			EventBus.$off('common-dialog-closed', this.close);
		},

		methods: {
			/**
			 * @name open
			 * @description set source of the video and open dialog
			 */
			open(obj) {
                this.obj = obj;
				this.$refs.dialog.open();
			},

			close() {
				this.obj = { source:null, h:null};
			}
		}
	};
</script>

<style scoped>
	.video-container {
		width: 100%;
		height: 100%;
		aspect-ratio: 1.77777;
	}
</style>
